import React, { Component } from 'react'
import { Row, Col, Modal } from 'react-bootstrap';
import Scheduler, { SchedulerData, DATE_FORMAT } from '../RosterScheduler';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

//components
import { CellUnits, ViewTypes } from '../../../../components/Scheduler';
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import withDragDropContext from '~/hoc/withDnDContext';

//elements
import Button from '~/components/CustomButton/CustomButton.jsx';
import Select from '../../../../elements/Select';
import LoadingSpinner from '~/elements/LoadingSpinner';

//utils
import { timeFormat } from '~/utils/dateFormat';

//assets
import CloseModalIcon from '../../../../assets/img/CloseApproveModalIcon.svg';

//styles
import '../RosterScheduler/css/style.css';
import Signature from '../../../../components/Signature/Signature';
import { Textarea } from '../../../../elements/Input';

const formatDepartments = (configDepartments = [], savedDepartments = []) => {
    const departments = configDepartments?.filter(ele => savedDepartments.includes(ele.code)).map(item => ({ label: item.name, value: item.code })) || [];
    if (savedDepartments.includes('z_none')) departments.push({ label: 'Others', value: 'z_none' });
    return departments
}

class GuestRosterMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            events: [],
            resources: [],
            byClock: false,
            viewModel: null,
            fromDate: null,
            toDate: null,
            signature: '',
            cyclesDetails: null,
            department: null,
            showApprovalModal: false,
            guest_email: '',
            departmentOptions: []
        };
        this.scheduleRef = React.createRef();
    }

    componentDidMount() {
        this.loadData();
    }

    getCustomDate = (schedulerData) => {
        const { viewType } = schedulerData;
        let { fromDate, toDate } = this.state;

        let startDate = '', endDate = '', cellUnit = CellUnits.Day;
        if (viewType === ViewTypes.Custom1) {
            startDate = moment(fromDate).format(DATE_FORMAT);
            endDate = moment(toDate).format(DATE_FORMAT);
            cellUnit = CellUnits.Day;
        }
        return {
            startDate,
            endDate,
            cellUnit
        };
    }

    loadData = async () => {
        try {
            const { rosterStore, authStore, t } = this.props;
            const departments = authStore.custConfig.departments;
            if (!departments?.length) {
                this.setState({ department: null })
                return;
            }

            this.setState({ isLoading: true })
            const resources = departments?.length ? await rosterStore.loadResources({ department: this.state.department ?? departments[0] }) : [];
            const res = await rosterStore.loadList({ department: this.state.department ?? departments[0] }, true, t);
            const { cycle_start_date, cycle_end_date } = res.cycleDetails && Object.values(res.cycleDetails)[0]
            this.setState({
                events: res.events,
                fromDate: cycle_start_date,
                toDate: cycle_end_date,
                resources,
                cyclesDetails: res.cycleDetails,
                departmentOptions: departments,
                department: this.state.department ?? departments[0],
                guest_email: authStore.custConfig.guestDetails.email
            }, () => {
                this.initRosterScheduler();
            })
        }
        catch (e) {
            console.error(e)
            this.setState({ isLoading: false })
        }
    }

    initRosterScheduler = async () => {
        const { t } = this.props;
        this.setState({ isLoading: true })
        let schedulerData = new SchedulerData(
            moment().format('YYYY-MM-DD'),
            ViewTypes.Custom1,
            false,
            false,
            {
                headerEnabled: false,
                startResizable: false,
                endResizable: false,
                movable: false,
                creatable: false,
                resourceName: t('Employee name'),
                nonAgendaOtherCellHeaderFormat: 'ddd | D',
                schedulerWidth: '78%',
                tableHeaderHeight: 75,
                eventItemHeight: 40,
                eventItemLineHeight: 40,
                yearCellWidth: 60,
            },
            { getCustomDateFunc: this.getCustomDate },
        );
        schedulerData.localeMoment.locale('en');
        schedulerData.commonStore = this.props.commonStore;
        schedulerData.setResources(this.state.resources);
        schedulerData.setEvents(this.state.events);
        this.setState({ viewModel: schedulerData }, () => {
            this.setState({ isLoading: false })
        })
    }

    customEventItemTemplate = (_, eventItem) => {
        const dateTimeRules = this.props.authStore.custConfig.client.data.dateTimeRules;
        return (
            <>
                {
                    this.state.byClock ?
                        <div style={{ textAlign: 'center', fontWeight: 'bold', color: 'black' }}>
                            <div style={{ fontSize: '10px' }}>{eventItem.title}</div>
                            <div style={{ fontSize: '8px' }}>{timeFormat(eventItem.startTime, dateTimeRules)}{(' to')}</div>
                            <div style={{ fontSize: '8px' }}>{timeFormat(eventItem.endTime, dateTimeRules)}</div>
                        </div>
                        :
                        <div
                            className='h-100'
                            style={{ marginX: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: 'black' }}
                        >
                            <div style={{ fontSize: '12px' }}>{eventItem.title}</div>
                        </div>
                }
            </>
        );
    };

    goNext = async () => {
        const { cyclesDetails, fromDate } = this.state;
        const findKey = Object.keys(cyclesDetails).findIndex(ele => ele === fromDate)
        if (Object.keys(cyclesDetails)[findKey + 1]) {
            const { cycle_start_date, cycle_end_date } = Object.values(cyclesDetails)[findKey + 1]
            this.setState({ fromDate: cycle_start_date, toDate: cycle_end_date }, () => {
                this.initRosterScheduler();
            });
        }
        else
            this.props.commonStore.addNotification(this.props.t('You dont have any further cycles to approve'), null, 'error')
    };

    goPrev = async () => {
        const { cyclesDetails, fromDate } = this.state;
        const findKey = Object.keys(cyclesDetails).findIndex(ele => ele === fromDate)
        if (Object.keys(cyclesDetails)[findKey - 1]) {
            const { cycle_start_date, cycle_end_date } = Object.values(cyclesDetails)[findKey - 1]
            this.setState({ fromDate: cycle_start_date, toDate: cycle_end_date }, () => {
                this.initRosterScheduler();
            });
        }
        else
            this.props.commonStore.addNotification(this.props.t('You dont have any past cycles to approve'), null, 'error')
    };

    handleDepartmentChange = (department) => {
        this.setState({ department }, () => { this.loadData() })
    }

    handleApproveReject = async (type) => {
        const { signature, comment, fromDate, toDate, resources, department } = this.state;
        if (!signature || !comment) {
            return;
        }

        const data = {
            signature,
            comment,
            status: type === 'approve' ? 'approved' : 'rejected',
            guest_email: this.state.guest_email,
            fromDate,
            toDate,
            department,
            userIds: resources.map(user => user.id)
        }

        const res = await this.props.rosterStore.approveOrRejectRoster(data);
        this.setState({ showApprovalModal: false, department: null }, async () => {
            await this.props.authStore.loadCustConfig()
            this.loadData();
        });
    }

    setDepartmentState = () => {
        this.loadData();
    }

    render() {
        const { viewModel, isLoading, fromDate, toDate, department, resources } = this.state;
        const { t, authStore } = this.props;
        const dateTimeRules = authStore.custConfig?.client?.data.dateTimeRules;
        const _departmentOptions = formatDepartments(authStore.custConfig?.client?.data?.departments, authStore.custConfig.departments)
        if (isLoading) return <LoadingSpinner />;

        if (!authStore.custConfig.departments?.length && !department) {
            return (
                <div className='d-flex justify-content-center'>
                    {t('No Roster Template found to Approve')}
                </div>
            )
        }

        if (authStore.custConfig.departments?.length && !department)
            this.setDepartmentState(authStore.custConfig.departments)

        return (
            <div ref={this.scheduleRef} className='roster-scheduler-container'>
                <Row className='mb-3'>
                    <Col>
                        <span className='fw-600 custom-customer-header'>{t('Roster')}</span>
                    </Col>
                </Row>
                <Row className='d-flex align-items-center mb-2'>
                    <Col md={3}>
                        <Select
                            placeholder={t('Select...')}
                            options={_departmentOptions}
                            value={_departmentOptions.find(ele => ele.value === department)}
                            onChange={e => this.handleDepartmentChange(e.value)}
                        />
                    </Col>
                    <Col md={6}>
                        <div style={{ width: '370px', fontSize: '14px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                            <div style={{
                                width: '330px', border: '1px solid #cccccc', borderRadius: '10px', paddingTop: '6px', paddingBottom: '6px',
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            }} >
                                <span span className='p-1' style={{ cursor: 0 ? 'not-allowed' : 'pointer' }} onClick={this.goPrev}>
                                    <b className="scheduleCaret rotate-90 m-1" ></b>
                                </span>
                                <span className="react-datepicker__input-container text-center">
                                    <span style={{ marginLeft: '35px', marginRight: '2px', fontWeight: 'bold' }}>
                                        {`${t('From')} (${moment(fromDate).format(dateTimeRules?.short_date_format)}) ${t('To')} (${moment(toDate).format(dateTimeRules?.short_date_format)})`}
                                    </span>
                                </span>
                                <span className='p-1 cursor-pointer' onClick={this.goNext}>
                                    <b className="scheduleCaret rotate-270 m-1" ></b>
                                </span>
                            </div>
                        </div>
                    </Col>
                    <Col className='d-flex justify-content-end' md={3}>
                        <Button fill onClick={() => this.setState({ showApprovalModal: true })}>
                            {t('Approve Roster')}
                        </Button>
                    </Col>
                </Row>

                {viewModel &&
                    <div id='Roster-Scheduler'>
                        <Scheduler
                            schedulerData={viewModel}
                            eventItemTemplateResolver={this.customEventItemTemplate}
                            showResourcesThreeDots={true}
                            handleResourceOptionClick={this.handleResourceOptionClick}
                            dateTimeRules={dateTimeRules}
                            t={t}
                        />
                    </div>}

                <Modal
                    className="modal fade"
                    show={this.state.showApprovalModal}
                    onHide={() => this.setState({ showApprovalModal: false })}
                >
                    <Modal.Header>
                        <Modal.Title>{t('Approve')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            className="cursor-pointer"
                            onClick={() => this.setState({ showApprovalModal: false })}
                            alt='close'
                        />
                    </Modal.Header>
                    <Modal.Body>
                        <div className="custom-form__row">
                            <div className="custom-form__col mb-4">
                                <div>
                                    <label className="control-label">{t('Signature')} </label>
                                    <Signature
                                        onChange={(signature) => {
                                            this.setState({ signature: signature });
                                        }}
                                        required
                                        width="100%"
                                        height={150}
                                        error={!this.state.signature}
                                    />
                                </div>
                            </div>
                        </div>
                        <Textarea
                            label={t('Comment')}
                            style={{ width: '100%' }}
                            value={this.state.comment}
                            name="comment"
                            onChange={(e) => this.setState({ comment: e.target.value })}
                            placeholder={t('Enter comments here')}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button fill wd icon style={{ backgroundColor: 'green', border: 0, alignItems: 'center' }}
                            onClick={() => this.handleApproveReject('approve')}
                        >
                            {t('Approve')} <i className="fa fa-check" />
                        </Button>
                        <Button fill wd icon style={{ backgroundColor: 'red', border: 0 }}
                            onClick={() => this.handleApproveReject('reject')}
                        >
                            {t('Reject')} <i className="fa fa-times" />
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default inject('commonStore', 'authStore', 'rosterStore')(withLocalization(applicationRouter(withDragDropContext(observer(GuestRosterMain)))));